export const buildQuery = (query: string, params?: Record<string, any>) => {
    let q = query;
    Object.keys(params ?? {}).forEach(key => {
        q = q?.replaceAll(`{{${key}}}`, params![key]);
    });
    return q;
};
